import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarRegularPlane from './calendar-regular-plane-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarRegularPlane {...validProps} />;
}

SvgComponent.iconName = 'calendar-regular-plane';

export const CalendarRegularPlaneIcon = svgIconWrapper(SvgComponent);
